module.exports = __webpack_public_path__ + "img/gold50.89fd9661.png";